export default __webpack_public_path__ + "static/media/bazzle_v_2.6492dcaa.png";